import { render, staticRenderFns } from "./DetailsOfReasonsByMonthsDiagram.vue?vue&type=template&id=6b8cdc9e&scoped=true&"
import script from "./DetailsOfReasonsByMonthsDiagram.vue?vue&type=script&lang=js&"
export * from "./DetailsOfReasonsByMonthsDiagram.vue?vue&type=script&lang=js&"
import style0 from "./DetailsOfReasonsByMonthsDiagram.vue?vue&type=style&index=0&id=6b8cdc9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8cdc9e",
  null
  
)

export default component.exports